export default __webpack_public_path__ + "static/media/facebook.371ba704.svg";